import { TextField } from "@mui/material";
import React from "react";

export const UswfInput = (props) => (
  <TextField
    sx={{
      "& .MuiInputBase-root": {
        borderRadius: 3,
        border: () =>
          props.error && props.value ? "1px solid orange" : "1px solid white",
        maxWidth: 300,
        maxHeight: 55,
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
      "& .MuiInputBase-input": {
        caretColor: "white",
        paddingTop: 2,
        paddingBottom: 2,
        color: "white",
        fontSize: 32,
        marginLeft: -0.25,
      },
      "& .MuiInputBase-input::placeholder": {
        color: "white",
        opacity: 0.75,
        fontSize: 32,
        fontFamily: '"proxima-nova", "sans-serif"',
        position: "relative",
        top: 0,
      },
      "& .MuiFormHelperText-root.Mui-error": {
        color: "orange",
        fontWeight: "bold",
      },
    }}
    variant="outlined"
    {...props}
    inputProps={{
      ...props.inputProps,
    }}
  />
);
